import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { AddPlanForm } from '../../../@shared/forms/setting/plans/add-plan-form/add-plan-form';
import { PricingPlansComponent } from './pricing-plans-component/pricing-plans-component';
import { PricingPlans } from '../../../models/pricing-plans';
import { Router } from '@angular/router';
import { UpdatePricingPlanForm } from '../../../@shared/forms/setting/plans/update-pricing-plan-form/update-pricing-plan-form';
import { DeletePricingPlanForm } from '../../../@shared/forms/setting/plans/delete-pricing-plan-form/delete-pricing-plan-form';
import { UpdateMileagePlanForm } from '../../../@shared/forms/setting/plans/update-mileage-plan-form/update-mileage-plan-form';
import { MileagePlans } from '../../../models/mileage-plans';
import { DeleteMileagePlanForm } from '../../../@shared/forms/setting/plans/delete-mileage-plan-form/delete-mileage-plan-form';
import { MileagePlanComponent } from './mileage-plan-component/mileage-plan-component';
import { AddMileagePlanForm } from '../../../@shared/forms/setting/plans/add-mileage-plan-form/add-mileage-plan-form';

@Component({
  selector: 'app-plans',
  imports: [PricingPlansComponent, AddPlanForm, UpdatePricingPlanForm, DeletePricingPlanForm, MileagePlanComponent, AddMileagePlanForm, UpdateMileagePlanForm, DeleteMileagePlanForm],
  templateUrl: './plans.html',
  styleUrl: './plans.scss'
})
export class Plans implements OnInit, AfterViewInit {


  @ViewChild(PricingPlansComponent) pricingPlansComp: PricingPlansComponent;
  @ViewChild(MileagePlanComponent) mileagePlanComp: MileagePlanComponent;

  activeTab = "0";

  selectedPricingPlan: PricingPlans;
  addPricingPlanDialog = false;
  updatePricingPlanDialog = false;
  deletePricingPlanDialog = false;

  selectedMileagePlan: MileagePlans;
  addMileagePlanDialog = false;
  updateMileagePlanDialog = false;
  deleteMileagePlanDialog = false;

  private router = inject(Router);

  ngOnInit() {
    this.onTabChange(this.activeTab)
  }

  ngAfterViewInit() {
    // Ensure child component initialized (PrimeNG creates them lazily)
    queueMicrotask(() => {
      this.onTabChange(this.activeTab);
    });
  }

  onTabChange = (tabValue?: string | number) => {
    this.activeTab = tabValue!.toString()!;

    this.router.navigate([], {
      queryParams: {
        page: null,
        size: null,
        search: null,
        id: null,
        sortBy: null,
        sortDirection: null,
        minPrice: null,
        maxPrice: null,
        minIncludedKilometers: null,
        maxIncludedKilometers: null,
        minDuration: null,
        maxDuration: null,
        durationUnit: null,
      },
      queryParamsHandling: 'merge'
    });

    if (tabValue === '0') {
      this.pricingPlansComp?.resetAll();
      this.pricingPlansComp?.loadData();
    } else if (tabValue === '1') {
      this.mileagePlanComp?.resetAll();
      this.mileagePlanComp?.loadData();
    }
  }

  openAddPricingPlanDialog = () => {
    this.addPricingPlanDialog = true
  }

  onPlanAdded = () => {
    this.pricingPlansComp?.loadData();
    this.addPricingPlanDialog = false;
  }

  openUpdatePricingPlanDialog = (pricingPlan: PricingPlans) => {
    this.selectedPricingPlan = pricingPlan;
    this.updatePricingPlanDialog = true;
  }

  onPricingPlanUpdated = () => {
    this.pricingPlansComp?.loadData();
    this.updatePricingPlanDialog = false;
  }

  openDeletePricingPlanDialog = (pricingPlan: PricingPlans) => {
    this.selectedPricingPlan = pricingPlan;
    this.deletePricingPlanDialog = true;
  }

  onPricingPlanDeleted = () => {
    this.pricingPlansComp?.loadData();
    this.deletePricingPlanDialog = false;
  }

  openAddMileagePlanDialog = () => {
    this.addMileagePlanDialog = true
  }

  onMileagePlanAdded = () => {
    this.addMileagePlanDialog = false
    this.mileagePlanComp?.loadData();
  }

   openUpdateMileagePlanDialog = (mileagePlan: MileagePlans) => {
    this.selectedMileagePlan = mileagePlan;
    this.updateMileagePlanDialog = true;
  }

  onMileagePlanUpdated = () => {
    this.mileagePlanComp?.loadData();
    this.updateMileagePlanDialog = false;
  }

  openDeleteMileagePlanDialog = (mileagePlan: MileagePlans) => {
    this.selectedMileagePlan = mileagePlan;
    this.deleteMileagePlanDialog = true;
  }

  onMileagePlanDeleted = () => {
    this.mileagePlanComp?.loadData();
    this.deleteMileagePlanDialog = false;
  }
}
